import { publicUrl } from '@chegg-wt/core/utils/url'
import { SITE_LOGO } from '@chegg-wt/core/components/Auth/testIds'
import AppLink from '@chegg-wt/core/components/AppLink'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { openModal } from '@chegg-wt/core/state/modals/actions'
import { ONE_AUTH_MODAL } from '@chegg-wt/core/state/modals/constants'
import {
  AuthModalData,
  AuthModalOrigin,
} from '@chegg-wt/core/components/Modals/AuthModal/types'
import { useDispatch, useSelector } from 'react-redux'
import { userEmailSelector } from '@chegg-wt/core/state/user/selectors'
import { ChevronIcon, ProfileIcon } from '@chegg-ui/theme'
import { SIGN_IN } from '@chegg-wt/core/constants/nav'
import { NavItem as NavItemProps } from '@chegg-wt/core/types/core'
import { enabledWAFeaturesSelector } from '@chegg-wt/core-wa/state/selectors'
import PopoverMenu from '@chegg-wt/core/components/PopoverMenu'
import * as Styled from '@chegg-wt/core/components/Nav/styled'
import { logout } from '@chegg-wt/core/state/user/actions'
import { setIsLoggingOut, setPaperList } from '@chegg-wt/core-wa/state/actions'
import { resetPaperAndEditor } from '@chegg-wt/core-wa/utils/helpers'
import {
  headerAccountItems,
  loggedInUserNavOptions,
  WRITING_ASSISTANT_RIGHT_NAV,
} from './constants'
import {
  AccountButtonWrapper,
  Email,
  HeaderLogo,
  HeaderRightNav,
  HeaderWrapper,
  Logo,
  Nav,
  NavItem,
  UserDetails,
} from './styled'

const WAnavDropdownItem = ({ item, dispatch }) => {
  const routes = useRoutesContext()
  return (
    <Styled.DropdownItem
      onClick={() => {
        if (item.name === 'Logout') {
          dispatch(setIsLoggingOut(true))
          dispatch(setPaperList([]))
          resetPaperAndEditor(dispatch)
          dispatch(logout())
        }
      }}
      hideOnSmall={item.hideOnSmall}
    >
      <AppLink
        replace={item.name === 'Logout'}
        route={item.route ? routes[item.route]({}) : { href: item.href }}
      >
        <Styled.DropdownLink
          className={item.icon}
          data-test={item.name}
          target={item.target}
        >
          {item.name}
        </Styled.DropdownLink>
      </AppLink>
    </Styled.DropdownItem>
  )
}

const LoggedInUserNavDropdown = ({ email, dispatch }) => {
  return (
    <PopoverMenu
      position="bottomLeft"
      targetElement={
        <Nav role="navigation">
          <AccountButtonWrapper>
            <UserDetails data-test={WRITING_ASSISTANT_RIGHT_NAV}>
              <ProfileIcon size="small" aria-hidden />
              <Email>{email}</Email>
              <ChevronIcon size="xsmall" aria-hidden />
            </UserDetails>
          </AccountButtonWrapper>
        </Nav>
      }
    >
      <Styled.DropdownMenuRight>
        {loggedInUserNavOptions.map((item) => (
          <WAnavDropdownItem key={item.name} item={item} dispatch={dispatch} />
        ))}
      </Styled.DropdownMenuRight>
    </PopoverMenu>
  )
}

export const HeaderContainer = () => {
  const { toCitationsHome } = useRoutesContext()
  const dispatch = useDispatch()
  const email = useSelector(userEmailSelector)
  const enabledWAFeaturesSelectorFlag = useSelector(enabledWAFeaturesSelector)
  const isMultiPaperEnabled = enabledWAFeaturesSelectorFlag.multiPaper

  const authHandler = (item: NavItemProps) => {
    const data: AuthModalData = {
      defaultFlow: item.name === SIGN_IN ? 'signin' : 'signup',
      origin: AuthModalOrigin.WRITING_ASSISTANT_PAGE,
    }
    dispatch(openModal({ name: ONE_AUTH_MODAL, data }))
  }

  return (
    <HeaderWrapper>
      <HeaderLogo>
        <AppLink route={toCitationsHome()}>
          <a data-test={SITE_LOGO}>
            <Logo src={publicUrl('/static/logo.svg')} data-test="logo-button" />
          </a>
        </AppLink>
      </HeaderLogo>
      {isMultiPaperEnabled && (
        <HeaderRightNav>
          {email ? (
            <LoggedInUserNavDropdown email={email} dispatch={dispatch} />
          ) : (
            headerAccountItems.map((item) => (
              <NavItem
                key={item.name}
                hideOnMobile={item.hideOnMobile}
                onClick={() => authHandler(item)}
                data-test={item.name}
              >
                {item.name}
              </NavItem>
            ))
          )}
        </HeaderRightNav>
      )}
    </HeaderWrapper>
  )
}
